import { createContext, FunctionComponent, ReactElement, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import Api from "src/Config";

export const GetAssigneeContext = createContext(null);

type Props = {
  children: ReactElement;
};

const GetAssigneeProvider: FunctionComponent<Props> = ({ children }) => {
  const { data, isLoading, error, isFetching } = useQuery({
    queryKey: ["assignee_list"],
    staleTime: 30000,
    queryFn: async () => {
      const {
        data: { data },
      } = await Api.get(`organisation/users`);

      return data;
    },
  });

  const contextValue = useMemo(
    () => ({
      isLoading,
      data,
      error,
      isFetching,
    }),
    [isLoading, data, error, isFetching],
  );
  return (
    <GetAssigneeContext.Provider value={contextValue}>
      {children}
    </GetAssigneeContext.Provider>
  );
};

export default GetAssigneeProvider;
